import loadable from '@loadable/component';
export const manifest = {
  'SmePartnersCommon.ConditionalDisplay': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonConditionalDisplay";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonConditionalDisplay" */
          './src/widgets/conditional-display'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/conditional-display");
            }

            return eval('require.resolve')("./src/widgets/conditional-display");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonConditionalDisplay
        })
      }
    }
  },
  'SmePartnersCommon.DataIterator': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonDataIterator";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonDataIterator" */
          './src/widgets/data-iterator'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/data-iterator");
            }

            return eval('require.resolve')("./src/widgets/data-iterator");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonDataIterator
        })
      }
    }
  },
  'SmePartnersCommon.PropsOverrider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonPropsOverrider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonPropsOverrider" */
          './src/widgets/props-overrider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/props-overrider");
            }

            return eval('require.resolve')("./src/widgets/props-overrider");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonPropsOverrider
        })
      }
    }
  },
  'SmePartnersCommon.UrlMapper': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonUrlMapper";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonUrlMapper" */
          './src/widgets/url-mapper'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/url-mapper");
            }

            return eval('require.resolve')("./src/widgets/url-mapper");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonUrlMapper
        })
      }
    }
  },
  'SmePartnersCommon.UrlMapperContext': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonUrlMapperContext";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonUrlMapperContext" */
          './src/widgets/url-mapper-context'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/url-mapper-context");
            }

            return eval('require.resolve')("./src/widgets/url-mapper-context");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonUrlMapperContext
        })
      }
    }
  },
  'SmePartnersCommon.GridLayout': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonGridLayout";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonGridLayout" */
          './src/widgets/grid-layout'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/grid-layout");
            }

            return eval('require.resolve')("./src/widgets/grid-layout");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonGridLayout
        })
      }
    }
  },
  'SmePartnersCommon.Pluralize': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePartnersCommonPluralize";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePartnersCommonPluralize" */
          './src/widgets/pluralize'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/pluralize");
            }

            return eval('require.resolve')("./src/widgets/pluralize");
          }

        }, {
          resolveComponent: m => m.SmePartnersCommonPluralize
        })
      }
    }
  }
};